export const POST = {
  ADMIN: {
    VOICE: {
      UPDATE: {
        IMAGE: '/admin/voice/update/image',
        NAME: '/admin/voice/update/name',
      },
    },
    STATS: {
      REFRESH: '/admin/stats/refresh',
    },
  },
  TTS: {
    GOOGLE: '/tts/google',
    ELEVENLABS: '/tts/elevenlabs',
  },
  STT: {
    TRANSCRIBE: '/stt/transcribe',
  },
  TTT: {
    STREAM: '/ttt/stream',
    CHAT: '/ttt/chat',
    POLISH: '/ttt/polish',
    EPUB: '/ttt/epub',
  },
  FLOWS: {
    GENERAL: {
      AUTHOR: '/flows/general/author',
      CATEGORISE: '/flows/general/categorise',
      CONTENT: {
        SCRIPT: '/flows/general/content/script',
        CHAIN: '/flows/general/content/chain',
        RETRY_MISSING: '/flows/general/content/retry_missing',
        ARTICLE: {
          RETRY: '/flows/general/content/article/retry',
          DELETE: '/flows/general/content/article/deletion',
          REORDER: '/flows/general/content/article/reorder',
          CANCEL: '/flows/general/content/article/cancel',
        },
        CHAPTER: {
          DELETE: '/flows/general/content/chapter/deletion',
        },
        INTRO: {
          RETRY: '/flows/general/content/intro/retry',
        },
        OUTRO: {
          RETRY: '/flows/general/content/outro/retry',
        },
      },
      CHARACTERS: '/flows/general/characters',
      SCENES: '/flows/general/scenes',
      SUMMARISE: '/flows/general/summarise',
      MEDITATION: '/flows/general/meditation',
      TRANSLATE: '/flows/general/translate',
      PODCAST: {
        INFORMATIONAL: '/flows/general/podcast/informational',
        CONVERSATIONAL: '/flows/general/podcast/conversational',
        BRIEFING: '/flows/general/podcast/briefing',
      },
      PICTURE_BOOK: '/flows/general/picture_book',
      ANTHOLOGY: {
        INSPIRE: '/flows/general/anthology/inspire',
        PLAN: '/flows/general/anthology/plan',
        EXTRACT_CONTINUITY: '/flows/general/anthology/extract_continuity',
        LINK_STORY: '/flows/general/anthology/link_story',
        BOOK_METADATA: '/flows/general/anthology/book_metadata',
        VALIDATE_BOOK_ORDER: '/flows/general/anthology/validate_book_order',
      },
    },
    TTS: {
      CONTENT: '/flows/tts/content',
      GENERATE: '/flows/tts/generate',
    },
    TTT: {
      STREAM: '/flows/ttt/stream',
      REWRITE: '/flows/ttt/rewrite',
    },
    TTI: {
      CHARACTERS: '/flows/tti/characters',
      SCENES: '/flows/tti/scenes',
    },
    PRODUCTION: '/flows/production',
  },
  SEARCH: {
    LIBRARY: '/search/library',
    SOUNDS: '/search/sounds',
    MUSIC: '/search/music',
  },
  ADVERT: {
    SSAI: {
      DYNAMIC: '/advert/ssai/dynamic',
    },
  },
  EDITING: {
    SUGGESTIONS: '/editing/suggestions',
    APPLY: '/editing/apply',
  },
  EXPORTS: {
    EPUB: '/exports/epub',
    DOC: '/exports/doc',
    PDF: '/exports/pdf',
    MARKDOWN: '/exports/markdown',
  },
  MODERATION: '/moderation',
  UPLOAD: '/upload',
  SCRAPING: {
    SINGLE: '/scraping/single',
    MULTIPLE: '/scraping/multiple',
  },
  IMAGES: {
    RESIZE: '/images/resize',
    GENERATE: '/images/generate',
  },
  VIDEO: {
    GENERATE: '/video/generate',
  },
  PAGES: {
    AUTHOR: '/pages/author',
    COLLECTION: '/pages/collection',
    GROUP: '/pages/group',
    LIBRARY: '/pages/library',
    RATING: '/pages/rating',
    BOOKMARKED: '/pages/bookmarked',
  },
  ACTIONS: '/actions',
  PUBLISHING: {
    PUBLISH: '/publishing/publish',
    UNPUBLISH: '/publishing/unpublish',
  },
  FOLLOWING: {
    FOLLOW: '/following/follow',
    UNFOLLOW: '/following/unfollow',
    CONFIG: '/following/config',
  },
  BOOKMARKING: {
    BOOKMARK: '/bookmarking/bookmark',
    UNBOOKMARK: '/bookmarking/unbookmark',
  },
  REVIEWING: {
    REVIEW: '/reviewing/review',
  },
  REPORTING: {
    REPORT: '/reporting/report',
  },
  BLOCKING: {
    BLOCK: '/blocking/block',
    UNBLOCK: '/blocking/unblock',
  },
  EXPORTING: {
    EPUB: '/exporting/epub',
  },
  LEADS: {
    CAPTURE: '/leads/capture',
  },
  MUSIC: '/music',
  SOUNDS: '/sounds',
  PAYMENTS: {
    VERIFY: '/payments/verify',
    PRODUCTS: {
      LIST: '/payments/products/list',
      PURCHASE: '/payments/products/purchase',
    },
  },
  GROUP: {
    FOLLOWERS: '/group/followers',
    EMAILS: {
      UPLOAD: '/group/emails/upload',
      UNSUBSCRIBE: '/group/emails/unsubscribe',
      MANAGE: '/group/emails/manage',
      SUBSCRIBERS: '/group/emails/subscribers',
      REMOVE: '/group/emails/remove',
    },
  },
  USER: {
    UPDATE: '/user/update',
    DELETE: '/user/remove',
    FOLLOWERS: '/user/followers',
    FOLLOWING: '/user/following',
    MIGRATE: '/user/migrate',
    EMAIL: {
      REGISTER: '/user/email/register',
    },
  },
  IMPORTS: {
    BEEHIIV: {
      RETRIEVE: '/imports/beehiiv/retrieve',
      EXTRACT: '/imports/beehiiv/extract',
      PROCESS: '/imports/beehiiv/process',
    },
  },
  DELETING: {
    REMOVE: '/deleting/remove',
  },
  VOICES: {
    USER: '/voices/user',
  },
  FEEDBACK: {
    SUBMIT: '/feedback/submit',
  },
  FRACXO: {
    ROLE: '/fracxo/role',
    SECTION: '/fracxo/section',
    CV: '/fracxo/cv',
    REJECTION: '/fracxo/rejection',
    MATCH: '/fracxo/match',
    DECLINE: '/fracxo/decline',
    NOTIFY: '/fracxo/notify',
    SKILL_GUIDANCE: '/fracxo/guidance',
    PROFILE_ITEM: '/fracxo/profile-item',
    PARSE_PDF: '/fracxo/pdf',
    SEARCH: '/fracxo/search',
    PUBLISH: '/fracxo/publish',
    UNPUBLISH: '/fracxo/unpublish',
  },
  NEWS: {
    NEWSDATA: {
      QUERY: '/news/newsdata/query',
    },
  },
  CHARACTERS: {
    EXTRACT: '/characters/extract',
  },
  CONTENT: {
    CATEGORY: '/content/category',
    CONTENT_TYPE: '/content/content_type',
    OWNER: '/content/owner',
  },
  SOCIAL: {
    LINKEDIN: '/social/social',
    LINKEDIN_GENERATE: '/social/linkedInGenerate',
  },
  PRICES: {
    CREDITS: '/prices/credits',
  },
  REWARDS: {
    STATUS: '/rewards/status',
    CLAIM: '/rewards/claim',
    TRACK: '/rewards/track',
    HISTORY: '/rewards/history',
  },
}
export const GET = {
  VOICES: {
    ALL: '/voices/all',
    GOOGLE: '/voices/google',
    ELEVENLABS: '/voices/elevenlabs',
  },
  COSTS: {
    VOICES: '/costs/voices',
  },
  SEARCH: {
    QUERY: '/search/query',
    SUGGESTIONS: '/search/suggestions',
  },
  CONTENT: {
    CATEGORY: '/content/category',
    CONTENT_TYPE: '/content/content_type',
    OWNER: '/content/owner',
  },
  AUTH: {
    LINKEDIN: '/auth/linkedin',
  },
}

export const ROUTES = {
  POST,
  GET,
}
